<template>
  <v-dialog v-model="dialog" persistent width="1200">
    <v-card class="p-0">
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          Modificar Horario
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md class="p-2" style="min-width: 100%">
            <v-layout wrap row>
              <v-flex md12 xs12>
                <v-text-field
                  label="Descripción"
                  v-model="form.descripcion"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-autocomplete
                  :items="tipo_jornada"
                  item-value="id"
                  item-text="tipo"
                  v-model="form.jornada"
                  label="Ingrese la jornada laboral"
                  :rules="$validate(['required'])"
                  outline
                  disabled
                  clearable
                  required
                />
              </v-flex>
            </v-layout>
            <v-chip color="#ff5c0a" text-color="white">Ingreso </v-chip>
            <v-layout wrap row>
              <v-flex md4 xs6>
                <v-text-field
                  label="Hora Ingreso "
                  v-model="form.horario"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Tolerancia en min."
                  v-model="form.tolerancia_1"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Rango inicio (Para procesar)"
                  v-model="form.rango_ini"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Rango fin (Para procesar)"
                  v-model="form.rango_fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-chip color="#3c00ff" text-color="white">Salida </v-chip>
            <v-layout wrap row>
              <v-flex md4 xs6>
                <v-text-field
                  label="Hora salida "
                  v-model="form.horario_2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Tolerancia en min."
                  v-model="form.tolerancia_2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Rango inicio en min. (Para procesar)"
                  v-model="form.rango_ini_2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs6>
                <v-text-field
                  label="Hora fin en min.(Para procesar)"
                  v-model="form.rango_fin_2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            @click="save()"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,

      tipo_jornada: [
        { id: "C", tipo: "CONTINUO" },
        { id: "D", tipo: "DISCONTINUO" }
        // { id: "D2", tipo: "DISCONTINUO TARDE" },
      ]
    };
  },
  mounted() {
    this.$bus.$on("openDialogModificarHorario", item => {
      this.form = item;
      if (this.form.joranada == "Jornada Continua") {
        this.form.jornada = "C";
      } else {
        this.form.jornada = "D";
      }

      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogModificarHorario");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let user = this.$storage.get("user");
        try {
          let rpta = await this.$service.graphql({
            query: `
                              query{
                                runQuery(consulta:"select control.fn_actualiza_horario_y_rangos(${parseInt(
                                  this.form.id_horario
                                )},'${this.form.descripcion}','${
              this.form.jornada
            }','${this.form.horario}','${this.form.rango_ini}','${
              this.form.rango_fin
            }','${this.form.tolerancia_1}','E',${parseInt(
              this.form.id_horario_rango_1
            )},'${this.form.horario_2}','${this.form.rango_ini_2}','${
              this.form.rango_fin_2
            }','${this.form.tolerancia_2}','S',${parseInt(
              this.form.id_horario_rango_2
            )},${user.id})"){
                                respuesta
                                }
                              }
                            `
          });
          rpta = rpta.runQuery.respuesta[0].fn_actualiza_horario_y_rangos;
          let resultado = rpta.split("|");
          if (rpta && resultado[0] == "1") {
            this.$message.success("El horario fué modificado exitosamente");
          } else {
            this.$message.warning(resultado[1]);
          }
        } catch (error) {
          console.log(error);
        }

        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/horario/dialogs/ModificarHorario.vue